import { ProductTemplateConfigType } from '#src/utils';

const config: ProductTemplateConfigType = {
  dynamicComponents: {
    FEEDBACK_MODAL: {
      template: 'standard',
      params: {
        subtitle: {
          contentKey: 'paymentpage.feedback.success.legacysubtitle',
        },
      },
    },
    HEADER: {
      template: 'standard',
      params: {
        title: {
          contentKey: 'paymentpage.page.legacytitle',
        },
      },
    },
  },
  overridesPerProduct: {
    AIRPORT_FAST_TRACK: {
      productFees: {
        contentKey: 'paymentpage.pricebreakdown.fasttrack.productfees',
      },
    },
  },
};

export default config;
